// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/Assets/images/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/Assets/images/minus.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-section .accordion {
  max-width: 915px;
  padding-top: 40px;
  margin: 0 auto;
}

.accordion-item {
  border: none;
  background: none;
}

.accordion-header {
  width: 100%;
}

.accordion-button {
  background: #EAF5F9;
  color: #163B6B;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  padding: 24px 32px;
  font-size: 16px;
  font-weight: 400;
  line-height: 138.889%;
}

.accordion-button::before {
  content: "";
  border-top: solid 1px rgba(22, 59, 107, 0.2);
  height: 1px;
  width: calc(100% - 64px);
  position: absolute;
  top: 0;
  left: 32px;
}

.accordion-button:not(.collapsed) {
  background-color: #EAF5F9;
  box-shadow: none;
}

.accordion-button::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  width: 24px;
  height: 24px;
  display: inline-block;
  position: absolute;
  right: 32px;
}

.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
}

.accordion-item:first-child .accordion-button {
  border-radius: 24px 24px 0 0;
}

.accordion-item:first-child .accordion-button::before {
  content: none;
}

.accordion-item:last-child .accordion-button.collapsed {
  border-radius: 0 0 24px 24px;
}

.accordion-body {
  padding: 24px 32px;
  position: relative;
}

.accordion-body::before {
  content: "";
  border-top: solid 1px rgba(22, 59, 107, 0.2);
  height: 1px;
  width: calc(100% - 64px);
  position: absolute;
  top: 0;
  left: 32px;
}

.severity-table-wrap {
  overflow-x: auto;
}

.severity-table {
  width: 100%;
  border-collapse: collapse;
}

.severity-table th,
.severity-table td {
  border: 1px solid #e5e7eb;
  padding: 5px;
  text-align: left;
  font-size: 14px;
}

.severity-table thead th {
  background: #EAF5F9;
  font-weight: 600;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .faq-section .accordion {
    padding-top: 24px;
    max-width: 100%;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .accordion-button {
    padding: 16px 40px 16px 16px;
    font-size: 12px;
  }
  .accordion-button::after {
    right: 16px;
    width: 16px;
    height: 16px;
    background-size: cover;
  }
  .accordion-button::before {
    left: 16px;
    width: calc(100% - 32px);
  }
  .accordion-body {
    padding: 16px;
  }
  .accordion-body::before {
    left: 16px;
    width: calc(100% - 32px);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Faqs/Faqs.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,YAAA;EACA,gBAAA;AADF;;AAGA;EACE,WAAA;AAAF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AACA;EACE,WAAA;EACA,4CAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AAEF;;AAAA;EACE,yBAAA;EACA,gBAAA;AAGF;;AADA;EACE,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AAIF;;AADA;EACE,yDAAA;EACA,sBAAA;AAIF;;AADA;EACE,4BAAA;AAIF;;AAFA;EACE,aAAA;AAKF;;AAHA;EACE,4BAAA;AAMF;;AAHA;EACE,kBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,WAAA;EACA,4CAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,WAAA;EACA,yBAAA;AAOF;;AAJA;;EAEE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAOF;;AAJA;EACE,mBAAA;EACA,gBAAA;AAOF;;AAHA;EAEM;IACI,iBAAA;IACA,eAAA;EAKR;AACF;AADA;EACE;IACE,4BAAA;IACA,eAAA;EAGF;EADA;IACI,WAAA;IACA,WAAA;IACA,YAAA;IACA,sBAAA;EAGJ;EADA;IACI,UAAA;IACA,wBAAA;EAGJ;EADA;IACI,aAAA;EAGJ;EADA;IACI,UAAA;IACA,wBAAA;EAGJ;AACF","sourcesContent":[".faq-section{\r\n  .accordion {\r\n    max-width: 915px;\r\n    padding-top: 40px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.accordion-item{\r\n  border: none;\r\n  background: none;\r\n}\r\n.accordion-header{\r\n  width: 100%;\r\n}\r\n.accordion-button {\r\n  background: #EAF5F9;\r\n  color: #163B6B;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  position: relative;\r\n  padding: 24px 32px;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 138.889%;\r\n}\r\n.accordion-button::before {\r\n  content: \"\";\r\n  border-top: solid 1px rgba(22, 59, 107, 0.2);\r\n  height: 1px;\r\n  width: calc(100% - 64px);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 32px;\r\n}\r\n.accordion-button:not(.collapsed) {\r\n  background-color: #EAF5F9;\r\n  box-shadow: none;\r\n}\r\n.accordion-button::after {\r\n  content: \"\";\r\n  background-image: url('../../../public/Assets/images/plus.svg');\r\n  background-size:cover;\r\n  width: 24px;\r\n  height: 24px;\r\n  display: inline-block;\r\n  position: absolute;\r\n  right: 32px;\r\n}\r\n\r\n.accordion-button:not(.collapsed)::after {\r\n  background-image: url(../../../public/Assets/images/minus.svg);\r\n  background-size:cover;\r\n}\r\n\r\n.accordion-item:first-child .accordion-button {\r\n  border-radius: 24px 24px 0 0;\r\n}\r\n.accordion-item:first-child .accordion-button::before {\r\n  content: none;\r\n}\r\n.accordion-item:last-child .accordion-button.collapsed {\r\n  border-radius: 0 0 24px 24px;\r\n}\r\n\r\n.accordion-body {\r\n  padding: 24px 32px;\r\n  position: relative;\r\n}\r\n.accordion-body::before {\r\n  content: \"\";\r\n  border-top: solid 1px rgba(22, 59, 107, 0.2);\r\n  height: 1px;\r\n  width: calc(100% - 64px);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 32px;\r\n}\r\n\r\n.severity-table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\n.severity-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.severity-table th,\r\n.severity-table td {\r\n  border: 1px solid #e5e7eb;\r\n  padding: 5px;\r\n  text-align: left;\r\n  font-size: 14px;\r\n}\r\n\r\n.severity-table thead th {\r\n  background: #EAF5F9;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n  .faq-section{\r\n      .accordion{\r\n          padding-top: 24px;\r\n          max-width: 100%;\r\n      }\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .accordion-button{\r\n    padding: 16px 40px 16px 16px;\r\n    font-size: 12px;\r\n  }\r\n  .accordion-button::after{\r\n      right: 16px;\r\n      width: 16px;\r\n      height: 16px;\r\n      background-size: cover;\r\n  }\r\n  .accordion-button::before{\r\n      left: 16px;\r\n      width: calc(100% - 32px);\r\n  }\r\n  .accordion-body{\r\n      padding: 16px;\r\n  }\r\n  .accordion-body::before{\r\n      left: 16px;\r\n      width: calc(100% - 32px);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
